
// ********* Import CSS ***************** //

import "./catering-menu.css";

// ********* Import Images ***************** //

//*** ASATTC Spinner Image ***//
import "/src/assets/asattc-round-favicon/asattc-round-favicon.png";

// ** LOGO ** //
import "/src/assets/logos/asattc-logo-purple.png";

// ** IMAGES ** //
import "/src/assets/asattc-food/asattc-chicken-wings-sauce.jpg";
import "/src/assets/asattc-food/asattc-rice-beef.jpg";

// ** ICONS ** //
import "/src/assets/menu-icons/dollar-sign.svg";
import "/src/assets/menu-icons/cleaning-hand.svg";
import "/src/assets/menu-icons/donation-hand.png";

// ********* Add Top Nav & Footer *************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';

// **************************** Spinner ****************************** //

$(window).on('load', function(){
  document.getElementById("spinner").style.display = "block";
  setTimeout(removeSpinner, 1000);
});

function removeSpinner(){
  $( "#spinner" ).fadeOut(100, function() {
    $( "#spinner" ).remove();
  });
}